/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { allocations_AllocationListResponse } from '../models/allocations_AllocationListResponse';
import type { allocations_AllocationResponse } from '../models/allocations_AllocationResponse';
import type { allocations_CreateAllocationRequest } from '../models/allocations_CreateAllocationRequest';
import type { allocations_UpdateAllocationRequest } from '../models/allocations_UpdateAllocationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AllocationsService {
    /**
     * List allocations
     * List allocations with pagination and optional filters (child_id, group_id, contract_id, from_date, to_date)
     * @param limit Limit
     * @param offset Offset
     * @param childId Filter by child ID
     * @param groupId Filter by group ID
     * @param contractId Filter by contract ID
     * @param fromDate Filter allocations from this date (yyyy-MM-dd format)
     * @param toDate Filter allocations to this date (yyyy-MM-dd format)
     * @returns allocations_AllocationListResponse OK
     * @throws ApiError
     */
    public static getApiV1Allocations(
        limit: number = 10,
        offset?: number,
        childId?: string,
        groupId?: string,
        contractId?: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<allocations_AllocationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/allocations',
            query: {
                'limit': limit,
                'offset': offset,
                'child_id': childId,
                'group_id': groupId,
                'contract_id': contractId,
                'from_date': fromDate,
                'to_date': toDate,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list allocations`,
            },
        });
    }
    /**
     * Create an allocation
     * Create a new child group allocation with validation
     * @param allocation Allocation data
     * @returns allocations_AllocationResponse Created
     * @throws ApiError
     */
    public static postApiV1Allocations(
        allocation: allocations_CreateAllocationRequest,
    ): CancelablePromise<allocations_AllocationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/allocations',
            body: allocation,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                500: `Failed to create allocation`,
            },
        });
    }
    /**
     * Delete an allocation
     * Soft-delete an allocation by ID
     * @param id Allocation ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Allocations(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/allocations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing allocation ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Allocation not found`,
                500: `Failed to delete allocation`,
            },
        });
    }
    /**
     * Get an allocation
     * Get an allocation by ID
     * @param id Allocation ID
     * @returns allocations_AllocationResponse OK
     * @throws ApiError
     */
    public static getApiV1Allocations1(
        id: string,
    ): CancelablePromise<allocations_AllocationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/allocations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing allocation ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Allocation not found`,
                500: `Failed to get allocation`,
            },
        });
    }
    /**
     * Update an allocation
     * Update an existing allocation with validation
     * @param id Allocation ID
     * @param allocation Allocation data
     * @returns allocations_AllocationResponse OK
     * @throws ApiError
     */
    public static putApiV1Allocations(
        id: string,
        allocation: allocations_UpdateAllocationRequest,
    ): CancelablePromise<allocations_AllocationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/allocations/{id}',
            path: {
                'id': id,
            },
            body: allocation,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Allocation not found`,
                409: `Concurrent modification detected`,
                500: `Failed to update allocation`,
            },
        });
    }
}
